// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__29EBR","links":"Footer_links__1i2Ky","icon":"Footer_icon__de2mD","footer_hero":"Footer_footer_hero__1kZrh","footer_nav":"Footer_footer_nav__xCl8v"};